import { TimeReport, TimeReportProjectItem } from "../types";
import { isSameTimeReportProjectItem } from "./isSameTimeReportProjectItem";
import { TimeReportProjectItemPath } from "./TimeReportProjectItemPath";

export const getTimeReportProjectItem = (
  timeReport: TimeReport,
  path: TimeReportProjectItemPath,
): TimeReportProjectItem | undefined => {
  const { projectGuid, payCodeGuid, date } = path;

  const compareItem = isSameTimeReportProjectItem(payCodeGuid, date);

  return timeReport.projects.find(p => p.project.guid === projectGuid)?.items.find(compareItem);
};
